/**
 * Static data backing the Compose Reply panel.
 *
 * Recipient suggestions and the default CC list now come from real data
 * (organization members + the org email address book); only the sending
 * mailbox and the suggested-response templates remain hard-coded for now.
 */

export interface ComposeContact {
  id: string;
  /** Display name shown on the recipient pill (e.g. "Trotman, Sheldon"). */
  name: string;
  email: string;
}

/** The (uneditable) sending mailbox. */
export const COMPOSE_FROM: { name: string; email: string } = {
  name: 'VTI Orders',
  email: 'orders@videojet.com',
};

export interface SuggestedResponse {
  key: string;
  label: string;
  /** Preset body inserted into the editor when the response is chosen. */
  html: string;
}

/**
 * Canned replies a clerk can drop into the body and then tweak. Kept as simple
 * HTML so they round-trip cleanly through the Lexical editor.
 */
export const SUGGESTED_RESPONSES: SuggestedResponse[] = [
  {
    key: 'price-adjustment',
    label: 'Price adjustment',
    html: [
      '<p>Hello,</p>',
      '<p>The pricing on your purchase order does not match our current quoted pricing. Could you review and confirm the updated pricing so we can proceed?</p>',
      '<p>Best regards,<br />VTI Orders</p>',
    ].join(''),
  },
  {
    key: 'item-replacement',
    label: 'Item replacement',
    html: [
      '<p>Hello,</p>',
      '<p>One or more items on your order are currently unavailable. We would like to propose a replacement of equal or better specification — let us know if that works, or if you would prefer to wait for restock.</p>',
      '<p>Best regards,<br />VTI Orders</p>',
    ].join(''),
  },
];
